var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-more_svg__a",
    d: "M9 9.6h4.2c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.2.2-.3.3-.3zm-2 0h.6c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H7c-.2 0-.3-.1-.3-.3v-.6c.1-.2.2-.3.3-.3zm2-2.5h4.2c.2 0 .3.1.3.3V8c0 .2-.1.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.7c0-.1.2-.2.3-.2zm-2 0h.6c.2 0 .3.1.3.3V8c0 .2-.1.3-.3.3H7c-.2 0-.3-.1-.3-.3v-.7c.1-.1.2-.2.3-.2zm2-2.3h4.2c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.2.2-.3.3-.3zm-2 0h.6c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H7c-.2 0-.3-.1-.3-.3v-.6c.1-.2.2-.3.3-.3zm5.7 9.8c1.1 0 2-.9 2-2V3.4h-9v8.4h4.5c.3 0 .6.3.6.6v.3c-.1 1.1.8 1.9 1.9 1.9zm-7.6 0h5.2c-.4-.5-.6-1-.7-1.7H3.4c0 1 .7 1.7 1.7 1.7zm-.6-2.8V3.4c0-.6.5-1.1 1.1-1.1h9c.6 0 1.1.5 1.1 1.1v9.3c0 1.7-1.4 3.1-3.1 3.1H5.1c-1.6 0-2.8-1.3-2.8-2.8v-.6c0-.3.3-.6.6-.6h1.6z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-more_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-more_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crm-more_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-more_svg__c",
    d: "M-898-1556H526V438H-898z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-more_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-more_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#crm-more_svg__d)",
    d: "M-2.7-2.7h23.5v23.5H-2.7z"
  }))));
}

export default SvgCrmMore;